import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ManagementService } from 'src/app/api/services';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-checkin-dialog',
  templateUrl: './checkin-dialog.component.html',
  styleUrls: ['./checkin-dialog.component.scss']
})
export class CheckinDialogComponent {

  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CheckinDialogComponent>,
    public managementService: ManagementService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public sharedService: SharedService,
    public translateService: TranslateService
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

  handleCheckIn() {
    this.loading = true;
    this.managementService.checkIn(this.dialogData?.idEvent, this.dialogData?.idAppointment).subscribe(
      res => {
        this.dialogRef.close(true)
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.sharedService.openSnackBar(
          this.translateService.instant('ERROR_GENERIC_RETRY'),
          true);
      }
    )
  }
}
